// Local translations
export const T = {
  en_GB: {
    title: "Reopen flow?",
    description:
      "This returns the flow to Draft so you can edit it. Your answers are kept. Submit it again to restart the process.",
    // Cancelled flows never entered the process, so there is nothing to undo.
    descriptionCancelled:
      "This returns the flow to Draft so you can edit it. Your answers are kept. The cancellation and its documents stay in the history.",
    forThisFlow: "For this flow:",
    signature: "The active signing request will be removed from this flow.",
    signatureCancel: "Cancellation will be requested from the signing provider.",
    pdfs: (count: number) => `${count} generated PDF will be deleted.`,
    pdfsPlural: (count: number) => `${count} generated PDFs will be deleted.`,
    compliance: "The pending compliance request will be withdrawn.",
    external: "The pending external approval request will be withdrawn.",
    draftOrders: "Unsigned draft investment orders will be removed.",
    historyNote: "Earlier decisions and feedback remain in process history.",
    reasonLabel: "Reason (optional)",
    reasonPlaceholder: "Why are you reopening this flow?",
    confirm: "Reopen flow",
    cancel: "Cancel",
  },
  nb_NO: {
    title: "Gjenåpne flyten?",
    description:
      "Dette setter flyten tilbake til Utkast slik at du kan redigere den. Svarene beholdes. Send den inn på nytt for å starte prosessen igjen.",
    descriptionCancelled:
      "Dette setter flyten tilbake til Utkast slik at du kan redigere den. Svarene beholdes. Kanselleringen og dokumentene beholdes i historikken.",
    forThisFlow: "For denne flyten:",
    signature: "Den aktive signeringsforespørselen fjernes fra flyten.",
    signatureCancel: "Kansellering blir etterspurt hos signeringsleverandøren.",
    pdfs: (count: number) => `${count} generert PDF slettes.`,
    pdfsPlural: (count: number) => `${count} genererte PDF-er slettes.`,
    compliance: "Den ventende compliance-forespørselen trekkes.",
    external: "Den ventende forespørselen om ekstern godkjenning trekkes.",
    draftOrders: "Usignerte utkast til investeringsordrer fjernes.",
    historyNote: "Tidligere beslutninger og tilbakemeldinger beholdes i prosesshistorikken.",
    reasonLabel: "Begrunnelse (valgfritt)",
    reasonPlaceholder: "Hvorfor gjenåpner du denne flyten?",
    confirm: "Gjenåpne flyten",
    cancel: "Avbryt",
  },
} as const;
